export default __webpack_public_path__ + "static/media/art.cd79e244.png";